// Backlog 125 (Storm 2026-10-21): one summary of the WHOLE call for wrap-up,
// both parts clearly marked (Reason for call, AI assistant, Agent, Outcome,
// Next actions). Asked for once per contact as wrap-up opens; the server
// (knktr-contact-summary) reads the transcript itself. The summary replaces
// the notes only when they hold nothing of the agent's own
// (lib/contactSummary.js); otherwise the screen offers "Add to notes".
// Any failure leaves wrap-up exactly as before. Kept out of WrapUp.jsx so the
// wrap-up screen itself stays fetch-free (verify-v3-wrapup check 18).
import { useEffect, useRef, useState } from 'react';
import { apiHeaders } from '../lib/consoleApi';
import { summaryMayReplaceNotes, fetchContactSummary } from '../lib/contactSummary';

const CONTACT_SUMMARY_URL = import.meta.env.VITE_CONTACT_SUMMARY_URL || '';

export function useContactSummary({ contactId, botSummary, callNotes, setCallNotes }) {
  const [state, setState] = useState({ status: 'idle', text: null, seeded: false });
  const latest = useRef({ callNotes, botSummary, setCallNotes });
  latest.current = { callNotes, botSummary, setCallNotes };
  useEffect(() => {
    if (!CONTACT_SUMMARY_URL || !contactId) return undefined;
    let live = true;
    setState({ status: 'loading', text: null, seeded: false });
    (async () => {
      const got = await fetchContactSummary({
        url: CONTACT_SUMMARY_URL,
        contactId,
        headers: await apiHeaders({ 'Content-Type': 'application/json' }),
      });
      if (!live) return;
      if (!got) { setState({ status: 'none', text: null, seeded: false }); return; }
      const now = latest.current;
      const replace = summaryMayReplaceNotes({ currentNotes: now.callNotes, botSummary: now.botSummary || null });
      if (replace) now.setCallNotes(got.text);
      setState({ status: 'ready', text: got.text, seeded: replace });
    })();
    return () => { live = false; };
  }, [contactId]);
  return state;
}
